import { Button, FileButton, Group, Title } from "@mantine/core";
import { useCsvHandler } from "../hook/useCsvHandler";

export const Header = () => {
  const { handleFieldChange, handleReset, resetRef } = useCsvHandler();

  return (
    <div>
      <Title>{"시험 공인인증 서비스"}</Title>
      <Group position="right">
        <FileButton
          onChange={handleFieldChange}
          accept="text/csv"
          resetRef={resetRef}
        >
          {(props) => <Button {...props}>{"파형 전송"}</Button>}
        </FileButton>
        <Button color="red" onClick={handleReset}>
          {"초기화"}
        </Button>
      </Group>
    </div>
  );
};
